import {styled} from "@mui/material/styles"

export type ContainerProps = {
    rotationDegrees: number
    width: number
}

export const Container = styled("img", {shouldForwardProp: p => p !== "rotationDegrees"})<ContainerProps>`
    transform: ${({rotationDegrees}) => `rotateZ(${rotationDegrees}deg)`};
    cursor: pointer;
    width: ${({width}) => `${width}rem`};
`
